// @flow
import React, { PureComponent } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Button, Grid } from '@mui/material';
import { logoutRequest } from 'redux/User/actions';
import { getRole, isAuthenticated } from 'redux/User/selectors';
import { connect } from 'react-redux';
import { Container } from './Header.style';
import logo from '../../assets/image_transparent.png';

type Props = {};
declare type StatePropsType = {
  role: String,
  isAuthenticated: Boolean,
};
declare type DispatchPropsType = {
  logoutUser: Function,
};
const mapStateToProps = (state: StoreType): DashboardStore => ({
  role: getRole(state),
  isAuthenticated: isAuthenticated(state),
});
const mapDispatchToProps = (dispatch: Function): DispatchPropsType => ({
  logoutUser: () => dispatch(logoutRequest()),
});
class Header extends PureComponent<Props & StatePropsType & DispatchPropsType> {
  constructor(props) {
    super(props);
    this.state = {
      role: null,
      isRoleLoaded: false,
      isAuthenticated: false,
    };
  }

  componentDidMount() {
    const { isAuthenticated } = this.props;
    this.setState({
      isRoleLoaded: isAuthenticated,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isAuthenticated !== this.props.isAuthenticated) {
      const { isAuthenticated } = this.props;
      this.setState({
        isRoleLoaded: isAuthenticated,
      });
    }
  }

  roleBasedRoutes = (role, route) => {
    if (role === 'admin' || role === 'mpr') {
      return true;
    }
    if (role === 'mr' && (route === 'mine-dashboard' || route === 'settings')) {
      return true;
    }
    return false;
  };

  handleLogout = async () => {
    const { logoutUser } = this.props;
    await logoutUser();
    const { history } = this.props;

    history.replace('/login');
  };

  render() {
    const {
      props: {
        location: { pathname },
      },
    } = this;
    const { isRoleLoaded } = this.state;
    const { role } = this.props;
    if (!isRoleLoaded) {
      return null; // or a loading spinner
    }
    return (
      <Container
        className="mdk-header js-mdk-header mb-0"
        id="header"
        data-fixed=""
        data-effects=""
        data-retarget-mouse-scroll=""
        data-domfactory-upgraded="mdk-header"
        style={{ paddingTop: '64px' }}
      >
        <div className="mdk-header__bg">
          <div className="mdk-header__bg-front" />
          <div className="mdk-header__bg-rear" />
        </div>
        <div className="mdk-header__content">
          <Grid
            className="navbar navbar-expand px-4 navbar-dark-pickled-bluewood navbar-shadow mdk-header--fixed"
            id="default-navbar"
            data-primary="data-primary"
          >
            <Link to="/" className="navbar-brand mr-16pt">
              <span className="avatar avatar-sm navbar-brand-icon mr-0 icon">
                <span className="avatar-title rounded ">
                  <i data-v-134867f8="" className="material-icons icon-32pt">
                    graphic_eq
                  </i>
                </span>
              </span>
              <span className="d-none d-lg-block">TACS</span>
            </Link>
            <Grid direction="column" alignItems="right">
              <Grid>
                <img src={logo} alt="logo" style={{ width: '50px', height: '50px' }} />
              </Grid>
            </Grid>
            {isRoleLoaded && (
              <>
                <Grid className="d-sm-none ml-auto" container justify="flex-end">
                  <Button
                    className="d-sm-none ml-auto"
                    style={{
                      textTransform: 'none',
                      color: '#fff',
                      backgroundColor: 'transparent',
                      padding: '4px 12px',
                    }}
                    onClick={this.handleLogout}
                  >
                    Logout
                  </Button>
                </Grid>
                <div className="flex" style={{ flex: 1 }}>
                  <ul className="nav navbar-nav d-none d-sm-flex flex justify-content-start ml-8pt" dir="rtl">
                    <li className="nav-item" />
                    <li className="nav-item">
                      <Button style={{ textTransform: 'none', fontWeight: '' }} className="nav-link" onClick={this.handleLogout}>
                        Logout
                      </Button>
                    </li>
                    {role && this.roleBasedRoutes(role, 'settings') && (
                      <li className="nav-item">
                        <Link to="/settings" className={`${pathname === '/settings' ? 'active' : ''} nav-link`}>
                          Settings
                        </Link>
                      </li>
                    )}
                    {role && this.roleBasedRoutes(role, 'reports') && (
                      <li className="nav-item">
                        <Link to="/reports" className={`${pathname === '/reports' ? 'active' : ''} nav-link`}>
                          Reports
                        </Link>
                      </li>
                    )}
                    {role && this.roleBasedRoutes(role, 'card-swaps') && (
                      <li className="nav-item">
                        <Link to="/card-swap" className={`${pathname === '/card-swap' ? 'active' : ''} nav-link`}>
                          Card Swap Logs
                        </Link>
                      </li>
                    )}
                    {role && this.roleBasedRoutes(role, 'pit-dashboard') && (
                      <li className="nav-item">
                        <Link to="/pit-dashboard" className={`${pathname === '/pit-dashboard' ? 'active' : ''} nav-link`}>
                          Pit Dashboard
                        </Link>
                      </li>
                    )}
                    {role && this.roleBasedRoutes(role, 'mine-dashboard') && (
                      <li className="nav-item">
                        <Link to="/dashboard" className={`${pathname === '/dashboard' ? 'active' : ''} nav-link`}>
                          Dashboard
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </>
            )}
          </Grid>
        </div>
      </Container>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
